<template>
  <div>
	<span>{{labelText}}</span>
    <div class="range-container">
      <div class="slider-track"></div>
      <div class="selected-range d-flex" :style="selectedRangeStyle"> </div>

      <!-- Min slider -->
      <input
        type="range"
        :min="min"
        :max="max"
        v-model.number="localMin"
        @input="updateMin"
      />

      <!-- Max slider -->
      <input
        type="range"
        :min="min"
        :max="max"
        v-model.number="localMax"
        @input="updateMax"
      />
    </div>
    ({{ localMin }}-{{ localMax }})
	
  </div>
</template>

<script>
export default {
  name: "DualRangeSlider",

  props: {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    value: {
      type: Object,
      default: () => ({ min: 0, max: 100 })
    },
	labelText:String
  },

  data() {
    return {
      localMin: this.value.min,
      localMax: this.value.max
    };
  },

  computed: {
    selectedRangeStyle() {
      const minPercent = (this.localMin / this.max) * 100;
      const maxPercent = (this.localMax / this.max) * 100;

      return {
        left: minPercent + "%",
        width: maxPercent - minPercent + "%"
      };
    }
  },

  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.localMin = newVal.min;
        this.localMax = newVal.max;
      }
    }
  },

  methods: {
    updateMin() {
      if (this.localMin > this.localMax) {
        this.localMax = this.localMin;
      }
      this.$emit("input", { min: this.localMin, max: this.localMax });
    },

    updateMax() {
      if (this.localMax < this.localMin) {
        this.localMin = this.localMax;
      }
      this.$emit("input", { min: this.localMin, max: this.localMax });
    }
  }
};
</script>
<style scoped>
 .range-container {
    width: 250px;
    position: relative;
    margin-top: 10px;
  }

  /* Base track */
  .slider-track {
    position: absolute;
    height: 6px;
    background: #ddd;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 3px;
  }

  /* Selected range bar */
  .selected-range {
    position: absolute;
    height: 6px;
    background: #0078ff;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 3px;
  }

  /* Min/Max labels */
  .range-min,
  .range-max {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #666;
    pointer-events: none;
  }

  .range-min { left: 0; }
  .range-max { right: 0; }

  /* Range inputs */
  input[type="range"] {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    pointer-events: none;
    -webkit-appearance: none;
  }

  /* Hide each slider's track (we draw our own) */
  input[type="range"]::-webkit-slider-runnable-track {
    height: 6px;
    background: transparent;
  }
  input[type="range"]::-moz-range-track {
    height: 6px;
    background: transparent;
  }

  /* Thumb */
  input[type="range"]::-webkit-slider-thumb {
    pointer-events: all;
    -webkit-appearance: none;
    height: 18px;
    width: 18px;
    background: #0078ff;
    border-radius: 50%;
    cursor: pointer;
    margin-top: -6px; /* centers thumb on 6px track */
  }

  input[type="range"]::-moz-range-thumb {
    pointer-events: all;
    height: 18px;
    width: 18px;
    background: #0078ff;
    border-radius: 50%;
    cursor: pointer;
  }

  .value-display {
    margin-top: 20px;
    font-size: 14px;
  }
 </style>